// Module
var code = "<ng2-bm-ng-select [items]=\"vm.items\" [selected]=\"vm.selected\" [multiple]=\"vm.multiple\" [placeholder]=\"vm.multiple ? 'Select horse(s)' : 'Select horse'\" [append-to]=\"vm.appendTo\" [dropdown-position]=\"vm.dropdownPosition\" (change-selected)=\"vm.onChangeSelected($event)\"> </ng2-bm-ng-select> ";
// Exports
module.exports = code;